import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Link } from 'react-router-dom'
import { Button, NoData } from 'components'
import styles from './index.module.css'
import { useNavigate } from 'react-router-dom'
import Lib from 'library'

const DataList = () => {

	const App = useApp()
	const navigate = useNavigate()

	const [dataProofList, setDataProofList] = useState() // 데이터 증명서 리스트
	const [pagination, setPagination] = useState() // 데이터 증명서 pagination
	const [moreN, setMoreN] = useState(1); // 더보기 index

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={() => navigate("/home")} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	useEffect(() => {
		Lib.get(`/api/data/crtf/lst/hist?pageNo=${moreN}`, (data, pagination) => {
			if (moreN === 1) {
				setDataProofList(data);
			} else {
				setDataProofList(prev => prev.concat(data));
			}
			setPagination(pagination);
		});
	}, [moreN])

	// 데이터 증명서 테스트
	// useEffect(() => {
	// 	const test = [
	// 		{
	// 			avlDt: "2022-04-10 02:24",
	// 			avlYn: "Y",
	// 			sendDt: "2022-04-04 16:24",
	// 			sno: "220404162310879",
	// 		},
	// 		{
	// 			avlDt: "2022-04-05 13:31",
	// 			avlYn: "Y",
	// 			sendDt: "2022-04-04 16:24",
	// 			sno: "220404162310879",
	// 		},
	// 		{
	// 			avlDt: "2022-04-05 02:24",
	// 			avlYn: "Y",
	// 			sendDt: "2022-04-04 16:24",
	// 			sno: "220404162310879",
	// 		},	{
	// 			avlDt: "2022-04-8 12:24",
	// 			avlYn: "Y",
	// 			sendDt: "2022-04-04 16:24",
	// 			sno: "220404162310879",
	// 		},
	// 		{
	// 			avlDt: "2022-04-02 02:24",
	// 			avlYn: "N",
	// 			sendDt: "2022-04-04 16:24",
	// 			sno: "220404162310879",
	// 		}
	// 	]
	// 	setDataProofList(test);
	// },[])

	const onMore = () => {
		setMoreN(prev => prev + 1)
	}

	const ProofMoreBtn = (pg) => {
		if (pg === undefined) { return false }
		if (pg.pageNo < pg.lastPage) {
			return (
				<div className="padding" onClick={() => onMore()}>
					<Button className="btn btn--big btn-more">+ 더보기</Button>
				</div>
			)
		}
	}

	const onTimeCheck = (item) => {
		const second = 1000;
		const minute = (second * 60);
		const hour = (minute * 60);
		const day = (hour * 24);

		//const _distance = new Date(item.avlDt) - new Date();
		const _distance = Lib.ChanageNewDate(item.avlDt) - new Date();
		//const numType = Math.sign(new Date(item.avlDt) - new Date());
		const numType = Math.sign(Lib.ChanageNewDate(item.avlDt) - new Date());
		const _days = Math.floor(_distance / day);
		const _hours = Math.floor((_distance % day) / hour);
		// 분,초 값 필요시 사용 현재는 기획서에서 시간단위로 표현요청해서 처리
		// let _minutes = Math.floor(( _distance % hour ) / minute );
		// let _seconds = Math.floor(( _distance % minute ) / second );

		if (item.avlYn === 'N') {
			return (
				<span className={`${styles.timer}`}><i className="icon icon_time mr_5" />만료</span>
			)
		} else if (numType > 0) {
			let day = _days > 0 ? _days + '일' : '';
			let hours = _hours > 0 ? _hours + '시간' : '1시간';
			return (
				<span className={`${styles.timer} text-red`}><i className="icon icon_time icon_time_red mr_5" />만료 {day} {hours}전</span>
			)
		} else {
			return (
				<span className={`${styles.timer}`}><i className="icon icon_time mr_5" />만료</span>
			)
		}
	}

	return (
		<div className="page">
			<div className="shadow">
				<div className="visual-area">
					<p className="title">
						나의 데이터를 누구에게나<br />쉽고 간편하게 공유해보세요.
					</p>
					<h2 className="mt_10" style={{ color: "var(--main-color)" }}>데이터 증명서</h2>
					<Link to="/home/dataSelect" className="btn-link btn--gradient mt_20">증명서 공유하기<i className="icon icon_btn_arrow_white ml_5" style={{ marginTop: "-0.3rem" }} /></Link>
					<div className={styles["data-object"]}></div>
				</div>
			</div>

			<h3 className="padding pb_20">데이터 증명서</h3>
			<ul className={`${styles["data-list"]} list-bg`}>
				{
					dataProofList ?
						dataProofList.length > 0 ?
							dataProofList.map((item, index) => {
								return (
									<li key={index}>
										<div>
											<p>{item.avlDt}</p>
											<span>No. {item.sno}</span>
										</div>
										{onTimeCheck(item)}
									</li>
								)
							})
							:
							<NoData text="등록된 데이터 증명서가 없습니다." />
						:
						[...new Array(3)].map((item, index) => (
							<li key={index}>
								<div>
									<p className="skeleton" style={{ width: "12rem" }} />
									<span className="skeleton" style={{ width: "8rem" }} />
								</div>
								<span className={`${styles.timer}`}><i className="skeleton" style={{ width: "1.7rem", height: "1.7rem" }} /><span className="skeleton ml_5" style={{ width: "3rem" }} /></span>
							</li>
						))
				}
			</ul>
			{ProofMoreBtn(pagination)}
		</div>
	)
}

export default DataList
